<template>
    <Layout>
        <div class="flex h-screen flex-wrap">
            <div class="bg-gray-900 text-white lg:w-1/2">
                <div class="mx-auto space-y-12 p-8 lg:max-w-[80%]">
                    <div class="flex justify-center">
                        <img src="/images/logos/aeroweb.png" alt="" class="h-32 w-64 object-contain" />
                    </div>

                    <p class="border-l-8 border-l-white pl-8 text-lg">
                        Vous pourrez gérer tous vos outils de recrutement à partir de notre application web
                        <a href="#" class="font-bold uppercase text-blue-600">Aeroweb</a>
                        .
                    </p>
                    <p class="border-l-8 border-l-white pl-8 text-lg">
                        Trouvez les meilleurs candidats pour pourvoir vos postes dans les meilleurs délais à travers la plateforme de
                        recrutement la plus performante de l'industrie!
                    </p>

                    <ul class="list-disc text-lg">
                        <li>Diffuser vos offres d'emplois à votre convenance</li>
                        <li>Communiquer directement avec les candidats</li>
                        <li>Créer vos événements de recrutement</li>
                        <li>Clavarder avec les candidats</li>
                        <li>Diffuser les nouvleles de votre entreprise aurpès de dizaines de milliers de travailleurs!</li>
                    </ul>

                    <p class="text-center text-sm">
                        Vous avez des questions? Communiquez avec nos experts!
                        <br />
                        <a href="mailto:rh@camaq.ca" class="text-blue-600 underline">rh@camaq.ca</a>
                        ou par téléphone au
                        <a href="tel:1-450-403-4300">1-450-403-4300</a>
                    </p>
                </div>
            </div>

            <div
                class="relative flex h-[200px] w-full items-center justify-center bg-cover bg-center bg-no-repeat lg:h-full lg:w-1/2"
                style="background-image: url('/images/company.jpg')"
            >
                <a
                    href="https://aeroweb.ca/connexion"
                    class="rounded-md bg-blue-600 p-4 text-xl font-medium text-white hover:bg-blue-700"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {{ $t('Post your jobs') }}
                </a>
            </div>
        </div>
    </Layout>
</template>

<script>
    export default {};
</script>
